<template>
  <el-dialog title="Advanced Search"
             :visible="dialogVisible"
             @close="closeDl"
             top="10vh"
             custom-class="dialog-advanced-search"
             @open="handleSearch"
  >
    <el-form class="search-form" label-position="top">
      <el-row :gutter="33">
        <el-col :span="6">
          <el-form-item label="Composition">
            <el-select v-model="compositionInput" style="width:100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in compositions"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Weight">
            <el-select v-model="weightInput" style="width:100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in weights"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="33">
        <el-col :span="6">
          <el-form-item label="Warp Yarn Count">
            <el-select v-model="warpYarnCountInput" style="width: 100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in warpYarnCounts"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Weft Yarn Count">
            <el-select v-model="weftYarnCountInput" style="width: 100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in weftYarnCounts"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Warp Density">
            <el-select v-model="warpDensityInput" style="width: 100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in warpDensitys"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Weft Density">
            <el-select v-model="weftDensityInput" style="width: 100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in weftDensitys"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="33">
        <el-col :span="6">
          <el-form-item label="Product Type">
            <el-select v-model="productTypeInput" style="width: 100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in productTypes"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Technology">
            <el-select v-model="technologyInput" style="width: 100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in technologys"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Pattren">
            <el-select v-model="pattrenInput" style="width: 100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in pattrens"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Style">
            <el-select v-model="styleInput" style="width: 100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in styles"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="33">
        <el-col :span="6">
          <el-form-item label="Finish">
            <el-select v-model="finishInput" style="width: 100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in finishs"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Color">
            <el-select v-model="colorInput" style="width: 100%" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in colors"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Fabric Type">
            <el-select v-model="fabricTypeInput" style="width: 100%" class="aaaa" filterable allow-create placeholder="input or select">
              <el-option
                v-for="(item,index) in fabricTypes"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <button class="button" @click="handleAdvanceSearchClick()">Advanced Search</button>
      <button class="button" @click="resetDialog()">Reset</button>
    </div>
  </el-dialog>
</template>
<script>
import { picSearch, mapImageSearchToProductIds, getQuickSearch } from '/api/goods'

export default {
  props: {
    showheader: true,
    dialogVisible: false
  },
  data: function () {
    return {
      showDialog: false,
      error: false,
      choosePage: -1,
      banner: [],
      mark: 0,
      home: [],
      loading: true,
      notify: '1',
      timer: '',
      navList: [],
      headerObj: {},
      showAdvance: false,
      Close: 'Close',
      searchType: '',
      input: '',
      compositionInput: '',
      warpYarnCountInput: '',
      weftYarnCountInput: '',
      warpDensityInput: '',
      weftDensityInput: '',
      productTypeInput: '',
      technologyInput: '',
      pattrenInput: '',
      styleInput: '',
      finishInput: '',
      colorInput: '',
      fabricTypeInput: '',
      weightInput: '',
      compositions: [],
      compValue: '',
      weights: [],
      weightValue: '',
      warpYarnCounts: [],
      warpYarnCountValue: '',
      warpDensitys: [],
      warpDensityValue: '',
      weftYarnCounts: [],
      weftYarnCountValue: '',
      weftDensitys: [],
      weftDensityValue: '',
      productTypes: [],
      productTypeValue: '',
      technologys: [],
      technologyValue: '',
      styles: [],
      styleValue: '',
      finishs: [],
      finishValue: '',
      colors: [],
      colorValue: '',
      fabricTypes: [],
      fabricTypeValue: '',
      pattrens: [],
      pattrenValue: '',

      // Lazy-load state for dropdown options
      optionsLoaded: false,
      optionsLoading: false,
      optionsLoadPromise: null
    }
  },
  methods: {
    linkTo (item) {
      if (item.type === 0 || item.type === 2) {
        // 关联商品
        this.$router.push({
          path: '/goodsDetails',
          query: {
            productId: item.productId
          }
        })
      } else {
        // 完整链接
        window.location.href = item.fullUrl
      }
    },
    handleIconClick () {
      if (this.input === '') {
      } else {
        this.$router.push({
          path: '/goods?r=' + Math.random() + '&cid=' + encodeURIComponent(this.input)
        })
      }
    },
    handleAdvanceSearchClick () {
      let queryStr = ''
      // if (this.compositionInput !== '') {
      // constituent
      queryStr += this.compositionInput + ' @'
      // }
      // if (this.weightInput !== '') {
      // grammage
      queryStr += this.weightInput + ' @'
      // }
      // if (this.warpYarnCountInput !== '') {
      // radial_yarn_count
      queryStr += this.warpYarnCountInput + ' @'
      // }
      // if (this.warpDensityInput !== '') {
      // radial_density
      queryStr += this.warpDensityInput + ' @'
      // }
      // if (this.weftYarnCountInput !== '') {
      // weft_yarn_count
      queryStr += this.weftYarnCountInput + ' @'
      // }
      // if (this.weftDensityInput !== '') {
      // weft_density
      queryStr += this.weftDensityInput + ' @'
      // }
      // if (this.productTypeInput !== '') {
      // type
      queryStr += this.productTypeInput + ' @'
      // }

      // if (this.technologyInput !== '') {
      // technology
      queryStr += this.technologyInput + ' @'
      // }
      // if (this.pattrenInput !== '') {
      // pattern
      queryStr += this.pattrenInput + ' @'
      // }
      // if (this.styleInput !== '') {
      // supply_type
      queryStr += this.styleInput + ' @'
      // }
      // if (this.finishInput !== '') {
      // tidy_way
      queryStr += this.finishInput + ' @'
      // }
      // if (this.colorInput !== '') {
      // color
      queryStr += this.colorInput + ' @'
      // }
      // if (this.fabricTypeInput !== '') {
      // fabric_position
      queryStr += this.fabricTypeInput + ' @'
      // }
      if (queryStr === '') {
      } else {
        // window.open('//' + window.location.host + '/#/goodSearch?r=' + Math.random() + '&advcid=' + encodeURIComponent(queryStr))
        //
        // this.$router.push({
        //   path: '/goods?r=' + Math.random() + '&advcid=' + encodeURIComponent(queryStr)
        // })
        let myurl = '/goodSearch?r=' + Math.random() + '&advcid=' + encodeURIComponent(queryStr)
        this.$emit('openLink', myurl)
        this.closeDl()
      }
    },
    handleBeforeUpload (file) {
      let fileData = new FormData()
      fileData.append('file', file)
      fileData.append('pn', 0)
      fileData.append('rn', 20)
      picSearch(fileData).then((res) => {
        if (res.code !== 20000) {
          this.$message.error(res.message || 'Image search failed')
          return
        }
        const products = mapImageSearchToProductIds(res).join(',')
        if (!products) {
          this.$message.info('No similar fabrics found')
          return
        }
        this.$router.push({ path: '/goods?r=' + Math.random() + '&products=' + products })
      }).catch(() => {
        this.$message.error('Image search failed. Please try again.')
      })
    },
    handleSearch () {
      // Element-UI el-dialog fires @open each time it opens.
      // We only fetch dropdown lists after the dialog is opened (lazy load), and cache them.
      this.ensureOptionsLoaded()
    },
    ensureOptionsLoaded (forceReload = false) {
      if (!forceReload && this.optionsLoaded) return Promise.resolve()
      if (!forceReload && this.optionsLoading && this.optionsLoadPromise) return this.optionsLoadPromise

      this.optionsLoading = true

      const types = [
        'composition',
        'weight',
        'warpYarnCount',
        'weftYarnCount',
        'warpDensity',
        'weftDensity',
        'productType',
        'technology',
        'pattren',
        'finish',
        'color',
        'fabricType',
        'style'
      ]

      this.optionsLoadPromise = Promise.all(types.map(t => this.loadOptions(t)))
        .then(() => {
          this.optionsLoaded = true
        })
        .finally(() => {
          this.optionsLoading = false
        })

      return this.optionsLoadPromise
    },
    loadOptions (oType) {
      let params = {
        params: {
          key: '',
          sType: oType
        }
      }
      return getQuickSearch(params).then(res => {
        // If backend returns empty, ensure the corresponding list becomes empty
        if (res === null || res === '') {
          res = []
        }
        var array = []
        for (var i = 0; i < res.length; i++) {
          var obj = {}
          obj.value = res[i]
          obj.label = res[i]
          array.push(obj)
        }
        switch (oType) {
          case 'weftYarnCount' :
            this.weftYarnCounts = array
            break
          case 'composition' :
            this.compositions = array
            break
          case 'weight' :
            this.weights = array
            break
          case 'warpYarnCount' :
            this.warpYarnCounts = array
            break
          case 'warpDensity' :
            this.warpDensitys = array
            break
          case 'weftDensity' :
            this.weftDensitys = array
            break
          case 'productType' :
            this.productTypes = array
            break
          case 'technology' :
            this.technologys = array
            break
          case 'pattren' :
            this.pattrens = array
            break
          case 'finish' :
            this.finishs = array
            break
          case 'color' :
            this.colors = array
            break
          case 'fabricType' :
            this.fabricTypes = array
            break
          case 'style' :
            this.styles = array
            break
        }
      })
    },
    querySearchAsync (queryString, cb) {
      this.searchType = ''
      // this.input = queryString
      if (this.input === undefined) {
        cb([])
        return
      }
      this.input = this.input.trim()
      if (this.input === '') {
        cb([])
        return
      } else {
        this.loadAll(this.input)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    compositionSearchAsync (queryString, cb) {
      this.searchType = 'composition'
      if (this.compositionInput === undefined) {
        cb([])
        return
      }
      this.compositionInput = this.compositionInput.trim()
      if (this.compositionInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.compositionInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    weightSearchAsync (queryString, cb) {
      this.searchType = 'weight'
      if (this.weightInput === undefined) {
        cb([])
        return
      }
      this.weightInput = this.weightInput.trim()
      if (this.weightInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.weightInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    warpYarnCountSearchAsync (queryString, cb) {
      this.searchType = 'warpYarnCount'
      if (this.warpYarnCountInput === undefined) {
        cb([])
        return
      }
      this.warpYarnCountInput = this.warpYarnCountInput.trim()
      if (this.warpYarnCountInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.warpYarnCountInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    weftYarnCountSearchAsync (queryString, cb) {
      this.searchType = 'weftYarnCount'
      if (this.weftYarnCountInput === undefined) {
        cb([])
        return
      }
      this.weftYarnCountInput = this.weftYarnCountInput.trim()
      if (this.weftYarnCountInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.weftYarnCountInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    warpDensitySearchAsync (queryString, cb) {
      this.searchType = 'warpDensity'
      if (this.warpDensityInput === undefined) {
        cb([])
        return
      }
      this.warpDensityInput = this.warpDensityInput.trim()
      if (this.warpDensityInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.warpDensityInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    weftDensitySearchAsync (queryString, cb) {
      this.searchType = 'weftDensity'
      if (this.weftDensityInput === undefined) {
        cb([])
        return
      }
      this.weftDensityInput = this.weftDensityInput.trim()
      if (this.weftDensityInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.weftDensityInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    productTypeSearchAsync (queryString, cb) {
      this.searchType = 'productType'
      if (this.productTypeInput === undefined) {
        cb([])
        return
      }
      this.productTypeInput = this.productTypeInput.trim()
      if (this.productTypeInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.productTypeInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    technologySearchAsync (queryString, cb) {
      this.searchType = 'technology'
      if (this.technologyInput === undefined) {
        cb([])
        return
      }
      this.technologyInput = this.technologyInput.trim()
      if (this.technologyInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.technologyInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    pattrenSearchAsync (queryString, cb) {
      this.searchType = 'pattren'
      if (this.pattrenInput === undefined) {
        cb([])
        return
      }
      this.pattrenInput = this.pattrenInput.trim()
      if (this.pattrenInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.pattrenInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    finishSearchAsync (queryString, cb) {
      this.searchType = 'finish'
      if (this.finishInput === undefined) {
        cb([])
        return
      }
      this.finishInput = this.finishInput.trim()
      if (this.finishInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.finishInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    colorSearchAsync (queryString, cb) {
      this.searchType = 'color'
      if (this.colorInput === undefined) {
        cb([])
        return
      }
      this.colorInput = this.colorInput.trim()
      if (this.colorInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.colorInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    fabricTypeSearchAsync (queryString, cb) {
      this.searchType = 'fabricType'
      if (this.fabricTypeInput === undefined) {
        cb([])
        return
      }
      this.fabricTypeInput = this.fabricTypeInput.trim()
      if (this.fabricTypeInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.fabricTypeInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    styleSearchAsync (queryString, cb) {
      this.searchType = 'style'
      if (this.styleInput === undefined) {
        cb([])
        return
      }
      this.styleInput = this.styleInput.trim()
      if (this.styleInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.styleInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    handleSelect (item) {
      this.input = item.value
    },
    closeDialog () {
      this.dialogVisible = false
    },
    resetDialog () {
      this.compositionInput = ''
      this.weightInput = ''
      this.warpDensityInput = ''
      this.warpYarnCountInput = ''
      this.weftYarnCountInput = ''
      this.weftDensityInput = ''
      this.productTypeInput = ''
      this.technologyInput = ''
      this.pattrenInput = ''
      this.styleInput = ''
      this.finishInput = ''
      this.colorInput = ''
      this.fabricTypeInput = ''
    },
    mounted () {
      this._getNavList()

      // this.showAdvance = true
    },
    closeDl () {
      this.$emit('closeDialog')
    }
  },
  created () {
    // this.$emit('setShowHeader', false)
    // this.loadOptions('')
    this.dialogVisible = false
    this.showDialog = false
    // this.handleSearch()
  }
}
</script>

<style lang="scss">
/* ::v-deep无效，去除scope。修改element-ui控件样式*/
.dialog-advanced-search {
  width: 1200px;
  padding: 20px;
  border-radius: 20px;

  .el-dialog__header {
    position: relative;
    height: 60px;
    line-height: 60px;
    padding: 0 22px 0 16px;
    background-color: #F3F4FF;
    border-radius: 10px;

    .el-dialog__title {
      color: #918CFF;
      font-size: 20px;
      font-weight: 700;
    }

    .el-dialog__headerbtn {
      top: 17px;
      font-size: 22px;

      &:hover .el-dialog__close {
        color: #918CFF;
      }
    }
  }

  .el-dialog__body {
    padding: 30px 16px 0;

    .el-form-item {
      margin-bottom: 28px;

      .el-form-item__label {
        padding: 0;
        height: 56px;
        line-height: 56px;
        color: #79797B;
        font-size: 16px;
        font-weight: 500;
      }

      .el-input {
        .el-input__inner {
          height: 50px;
          line-height: 50px;
          border-radius: 10px;
          color: #918CFF;

          &:focus {
            border-color: #918CFF;
          }
        }

        &.is-focus {
          .el-input__inner {
            border-color: #918CFF;
            box-shadow: 0 0 0 2px #E4E5FE;
          }
        }
      }
    }
  }

  .el-dialog__footer {
  }
}
</style>
<style scoped lang="scss">
.dialog-advanced-search .button {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  width: 127px;
  background-color: #B7BBFD;
  border-radius: 5px;
  font-size: 14px;
  color: white;
  cursor: pointer;

  &:hover {
    background-color: #918CFF;
  }

  + .button {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// advancedSearch.vue?8bb2c7e8